import axiosClient from '../axiosClient';
import type { AxiosRequestConfig } from 'axios';
export interface MenuTargetSearchResult {
  targetType: string;
  targetPublicId: string;
  name: string;
  isSystemGeneratedDataView?: boolean | null;
  description?: string | null;
  schemaName?: string | null;
  tableName?: string | null;
  workspaceName?: string | null;
  modelName?: string | null;
  targetSubType?: string | null;
  iconType?: string | null;
  behaviorType?: string | null;
  targetDisplayName?: string | null;
}

export interface MenuTargetSearchResponse {
  results: MenuTargetSearchResult[];
  totalCount: number;
}

export async function searchMenuTargets (
  query: string,
  signal?: AbortSignal
): Promise<MenuTargetSearchResponse> {
  const config: AxiosRequestConfig = {
    params: { query },
    signal
  };

  const response = await axiosClient.get<MenuTargetSearchResponse>('v2/database/system/search/menu-targets', config);
  return response.data;
}
